import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../../ui/base-components/pai-button';

interface Props {
  open: boolean;

  handleClose(): void;
}

const AccountAlreadySyncedDialog: React.FC<Props> = ({ open, handleClose }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('accountAlreadySyncedDialogTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.text}>{t('accountAlreadySyncedDialogContent1')}</Typography>
          <Typography className={classes.text}>{t('accountAlreadySyncedDialogContent2')}</Typography>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiButton text={t('ok')} size={'small'} border={'rounded'} action={handleClose} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: 'linear-gradient(to right, #5044FF, #4AA4FF)',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default AccountAlreadySyncedDialog;
